<template>
    <a-modal
        :visible="true"
        :centered="true"
        :keyboard="false"
        :mask-closable="false"
        @ok="handleOk"
        @cancel="cancel"
        title="修改图片"
        okText="点击上传"
        width="900px"
    >
        <div class="cropper-content">
            <!-- 剪裁框 -->
            <div class="cropper">
                <img ref="imageRef" :src="image" alt />
            </div>
            <!-- 预览框 -->
            <div class="show-preview">
                <div class="preview previewBefore"></div>
            </div>
        </div>
        <div class="cropper-fn">
            <a-button @click="cropperZoom(0.05)">
                <ant-icon type="ZoomInOutlined"></ant-icon>
            </a-button>
            <a-button @click="cropperZoom(-0.05)">
                <ant-icon type="ZoomOutOutlined"></ant-icon>
            </a-button>
            <a-button @click="cropperRotate(-90)">
                <ant-icon type="UndoOutlined"></ant-icon>
            </a-button>
            <a-button @click="cropperRotate(90)">
                <ant-icon type="RedoOutlined"></ant-icon>
            </a-button>
            <a-button @click="sureSava">
                <ant-icon type="VerticalAlignBottomOutlined"></ant-icon>
            </a-button>
        </div>
    </a-modal>
</template>
 <script lang="ts">
import { defineComponent, reactive, ref, toRefs, onMounted } from "vue";
import { saveAs } from "file-saver";
import moment from "moment";
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
export default defineComponent({
    isGlobal: true,
    name: "ImgCropper",
    props: {
        image: {
            type: String,
            default: "",
        },
        cropperInfo: {
            type: Object,
            default: {
                width: 320,
                height: 200,
            },
        }
    },
    emits: ["closeCropper", "saveCropper"],
    setup(props, { emit }) {
        const state = reactive<{
            imageRef: any,
            image: string,
            cropper: any,
            code: number,
            originRotate: number,
        }>({
            // 裁剪后的图片
            imageRef: null,
            // 裁剪的图片
            image: props?.image,
            // 进行裁剪
            cropper: null,
            code: 1,
            originRotate: 0
        })

        const init = () => {
            state.cropper = new Cropper(state.imageRef, {
                aspectRatio: props?.cropperInfo.width / props?.cropperInfo?.height,
                guides: false,
                viewMode: 1,
                dragMode: 'move',
                background: true,
                preview: '.previewBefore',
                autoCropArea: 1,
                zoomOnWheel: true,
                center: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
                ready() {
                    const cropperRefDom = document.querySelector('.cropper-crop-box') as any;
                    cropperRefDom.setAttribute("css-before-content",`${props?.cropperInfo?.width} / ${props?.cropperInfo?.height}`);        // 里用属性设置css 显示裁剪宽高
                }
            },
            )
        }

        // 缩放
        const cropperZoom = (val) => {
            state.cropper.zoom(val)
        }

        // 旋转
        const cropperRotate = (val) => {
            state.originRotate += val;
            state.cropper.reset();
            state.cropper.rotateTo(state.originRotate);
        }

        // 保存
        const sureSava = () => {
            const afterImg = state.cropper
                .getCroppedCanvas({
                    width: props?.cropperInfo?.width,
                    height: props?.cropperInfo?.height,
                    imageSmoothingQuality: 'high'
                }).toDataURL('image/png')

            saveAs(afterImg, createImgName());
            state.code += 1;
        }

        const handleOk = () => {
            state.cropper
                .getCroppedCanvas({
                    width: props?.cropperInfo?.width,
                    height: props?.cropperInfo?.height,
                    imageSmoothingQuality: 'high'
                }).toBlob((blob) => {
                    emit("saveCropper", new File([blob], `${originName() || state.code}.png`))
                })
        }

        // 编一个名字
        const createImgName = () => {
            return `下载图片${moment(new Date()).format("YYYYMMDD")}${(Array(4).join('0') + state.code).slice(-4)}.png`
        }

        // 获取url图片名称
        const originName = () => {
            let strList = state.image.split('-');
            let name = strList[strList.length - 1];
            let nameList = name.split('.');
            name = nameList[0];
            return name
        }

        const cancel = () => {
            emit("closeCropper")
        }

        onMounted(() => {
            init()
        })


        return {
            ...toRefs(state),
            cropperZoom,
            cropperRotate,
            sureSava,
            handleOk,
            cancel,
        };
    },
});
</script>
  
  <style lang="less" scoped>
.cropper {
    border: 1px solid #fff;
    img {
        width: 100%;
        opacity: 0;
    }
}
.cropper-content {
    display: flex;
    justify-content: flex-end;
}
.cropper-content .cropper {
    width: 450px;
    height: 500px;
    overflow: hidden;
}
.cropper-content .show-preview {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background: #cccccc;
    margin: 0 25px;
}
.preview {
    overflow: hidden;
    border: 1px solid #468ac8;
    background: #cccccc;
}

:deep(.cropper-crop-box::before) {
    position: absolute;
    top: -26px;
    left: 0;
    background: #000;
    color: #fff;
    height: 20px;
    content: attr(css-before-content);
    font-size: 14px;
    display: flex;
    align-items: center;
    padding: 0 8px;
}

.previewBefore {
    width: 100%;
    height: 100%;
    overflow: hidden;
}
.cropper-fn {
    display: flex;
    margin-top: 20px;
}
</style>
  